import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import DefaultLayoutHeader from '../components/Layouts/DefaultLayoutHeader';
import LeftNavigation from '../components/Layouts/LeftNavigation';
import MobileFooter from '../components/Layouts/MobileFooter';

import './defaultLayout.css';
import MobileRightNavigation from '../components/Layouts/MobileRightNavigation';
import MobileNav from '../components/Layouts/MobileNav';
import { useDispatch, useSelector } from 'react-redux';
import { toggleBtn } from '../features/navbarToggler/navbarSlice';

type DefaultLayoutProps = {
  children?: React.ReactNode;
  businessPage?: boolean;
  title?: string;
  icon?: string;
  ltd?: boolean;
};
const DefaultLayout = ({ children, title, icon, ltd = false }: DefaultLayoutProps) => {
  const location = useLocation();
  const isOpen = useSelector((state: any) => state.button.isOpen);
  const dispatch = useDispatch();

  const handleClick = () => {
    dispatch(toggleBtn());
  };

  return (
    <>
      <div className='flex w-full'>
        {isOpen && (
          <div
            // onClick={handleClick}
            className='overlay fixed-top left-0 z-40 h-screen w-screen bg-[#061A1480]'
          />
        )}
        <aside
          className={`z-50 h-screen md:hidden ${
            isOpen
              ? 'fixed top-0 left-0 transform transition-transform'
              : '-translate-x-[100vw] xl:translate-x-0'
          }`}
        >
          <MobileNav isOpen={isOpen} setIsOpen={handleClick} />
        </aside>
        <aside className='w-[0] md:w-[235px]  h-screen'>
          <LeftNavigation />
        </aside>
        <section className={`w-[100%] md:w-[calc(100%-235px)]  `}>
          <div className='md:mt-4'>
            <DefaultLayoutHeader icon={icon} title={title} />
          </div>
          <div className='bg-white min-h-full '>
            <main
              className={`min-w-[calc(100%-235px)] !mb-[100px] lg:!mb-0 lg:!pt-0 !mt-[80px] mx-3 md:mx-7 ${
                ltd && 'lg:!ml-0'
              }
                ${location.pathname === '/my-business' && 'sl:!mx-0'}
                ${location.pathname === '/settings/profile-information' && 'lg:!mx-0'}
                ${location.pathname === '/settings/security' && 'lg:!mx-0'}
                ${location.pathname === '/settings/payment-services' && 'lg:!mx-0'}
                ${location.pathname === '/settings/business-information' && 'lg:!mx-0'}
                ${location.pathname === '/settings/reset-security-questions' && 'lg:!mx-0'}

                ${location.pathname === '/my-business/business-registration' && 'lg:!mx-0'}
                ${location.pathname === '/my-business/incorporated-trustee' && 'lg:!mx-0'}
                ${location.pathname === '/my-business/limited-liability' && 'lg:!mx-0'}
                `}
            >
              {children}
            </main>
            <div className=' md:hidden fixed bottom-0 w-full'>
              <MobileFooter />
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default DefaultLayout;
